const R = require('ramda');

exports.MAINTENANCE_MODES = {
  READ_ONLY: 'readonly',
  UNAVAILABLE: 'unavailable'
};

const sourcesMap = R.compose(
  R.concat(['subscription']),
  R.concat(['max8rnbo']),
  R.map(R.concat('max')),
  R.map(num => '' + num)
)
exports.AUTH_TYPE = {
  AUTHORIZE: 'authorize',
  REAUTHORIZE: 'reauthorize'
}
exports.NEVER = new Date('7474-07-04T04:00:00Z').toUTCString()
exports.MECHANISMS = {
  INSTITUTION_AC: 'institution_acs',
  RESELLER_AC: 'reseller_acs',
  RESELLER: 'reseller',
  FASTSPRING: 'fastspring',
  FIRSTLOGIN: 'firstlogin',
  COVID: 'covid',
  USER: 'user',
  SERIAL_UPGRADE: 'serial_upgrade'
}

exports.REJECTED_DEMO = 'REJECTED_DEMO';

const TYPES = {
  FULL: 'full',
  SUBSCRIPTION: 'subscription',
  DEMO: 'demo',
  TERM: 'term'
}

exports.TYPES = TYPES;

exports.AC_TYPES = {
  FULL: 'full',
  TERM_DATE: 'term-date',
  TERM_DAYS: 'term-days'
}

exports.AC_STATUS_FILTERS = {
  ALL: 'all',
  CLAIMED: 'claimed',
  UNCLAIMED: 'unclaimed'
};

exports.VALID_LICENSE_ADDITIONS = [
  'max7',
  'max8',
  'max8-rnbo',
  'max9',
  'max9-rnbo',
];

exports.ACCEPTED_LOCALES = [
  "en",
  "ja",
];

const EMAIL_TEMPLATES = {
  ACCOUNT_RECOVERY: "account-recovery",
  ACCOUNT_RECOVERY_JA: "account-recovery~ja~",
  EMAIL_CHANGE_NOTIFICATION: "mail-change-notification",
  EMAIL_CHANGE_NOTIFICATION_JA: "mail-change-notification~ja~",
  EMAIL_CHANGE_VERIFY: "mail-change-verify",
  EMAIL_CHANGE_VERIFY_JA: "mail-change-verify~ja~",
  PASSWORD_CHANGE_NOTIFICATION: "password-change-notification",
  PASSWORD_CHANGE_NOTIFICATION_JA: "password-change-notification~ja~",

  ANON_LICENSE_RETRIEVAL: "anon-retrieval",
  ANON_LICENSE_RETRIEVAL_JA: "anon-retrieval~ja~",
  RETRIEVAL_REMINDER: "retrieval-reminder",
  ACCOUNT_VERIFY_EN_WEB: "account-verify-en-web",
  ACCOUNT_VERIFY_EN_MAX: "account-verify-en-max",
  ACCOUNT_VERIFY_JP_WEB: "account-verify-en-web~ja~",
  ACCOUNT_VERIFY_JP_MAX: "account-verify-en-max~ja~",
  ILOK_REQUEST: "ilok-request",
  INSTITUTIONAL_ADMIN_INVITE: "inst-admin-invite",
  ADMIN_ACCOUNT_ARCHIVED: "admin-account-archived"
};

exports.ACCOUNT_RECOVERY_TEMPLATES = {
  "en": EMAIL_TEMPLATES.ACCOUNT_RECOVERY,
  "ja": EMAIL_TEMPLATES.ACCOUNT_RECOVERY_JA,
};

exports.ACCOUNT_VERIFY_WEB_TEMPLATES = {
  "en": EMAIL_TEMPLATES.ACCOUNT_VERIFY_EN_WEB,
  "ja": EMAIL_TEMPLATES.ACCOUNT_VERIFY_JP_WEB,
};

exports.ACCOUNT_VERIFY_MAX_TEMPLATES = {
  "en": EMAIL_TEMPLATES.ACCOUNT_VERIFY_EN_MAX,
  "ja": EMAIL_TEMPLATES.ACCOUNT_VERIFY_JP_MAX,
};

exports.EMAIL_CHANGE_NOTIFICATION_TEMPLATES = {
  "en": EMAIL_TEMPLATES.EMAIL_CHANGE_NOTIFICATION,
  "ja": EMAIL_TEMPLATES.EMAIL_CHANGE_NOTIFICATION_JA,
};

exports.EMAIL_CHANGE_VERIFY_TEMPLATES = {
  "en": EMAIL_TEMPLATES.EMAIL_CHANGE_VERIFY,
  "ja": EMAIL_TEMPLATES.EMAIL_CHANGE_VERIFY_JA,
};

exports.PASSWORD_CHANGE_NOTIFICATION_TEMPLATES = {
  "en": EMAIL_TEMPLATES.PASSWORD_CHANGE_NOTIFICATION,
  "ja": EMAIL_TEMPLATES.PASSWORD_CHANGE_NOTIFICATION_JA,
};

exports.EMAIL_TEMPLATES = EMAIL_TEMPLATES;

exports.EMAIL_TEMPLATE_SUBJECTS = {
  [EMAIL_TEMPLATES.ACCOUNT_RECOVERY]: "Cycling '74 Account Recovery",
  [EMAIL_TEMPLATES.ACCOUNT_RECOVERY_JA]: "Cycling '74 アカウントの復元",
  [EMAIL_TEMPLATES.ANON_LICENSE_RETRIEVAL]: "Activate your Max purchase",
  [EMAIL_TEMPLATES.ANON_LICENSE_RETRIEVAL_JA]: "Maxの購入を有効にする",
  [EMAIL_TEMPLATES.RETRIEVAL_REMINDER]: "Activate your unclaimed Max license",
  [EMAIL_TEMPLATES.EMAIL_CHANGE_VERIFY]: "Cycling '74 Email Verification",
  [EMAIL_TEMPLATES.EMAIL_CHANGE_VERIFY_JA]: "Cycling '74 電子メールの認証",
  [EMAIL_TEMPLATES.EMAIL_CHANGE_NOTIFICATION]: "Notification of Cycling '74 Account Change",
  [EMAIL_TEMPLATES.EMAIL_CHANGE_NOTIFICATION_JA]: "Cycling '74 アカウント変更のお知らせ",
  [EMAIL_TEMPLATES.PASSWORD_CHANGE_NOTIFICATION]: "Notification of Cycling '74 Account Change",
  [EMAIL_TEMPLATES.PASSWORD_CHANGE_NOTIFICATION_JA]: "Cycling '74 アカウント変更のお知らせ",
  [EMAIL_TEMPLATES.ACCOUNT_VERIFY_EN_WEB]: "Cycling '74 User Account Creation",
  [EMAIL_TEMPLATES.ACCOUNT_VERIFY_JP_WEB]: "Cycling '74 ユーザアカウントの作成",
  [EMAIL_TEMPLATES.ACCOUNT_VERIFY_EN_MAX]: "Cycling '74 User Account Creation",
  [EMAIL_TEMPLATES.ACCOUNT_VERIFY_JP_MAX]: "Cycling '74 ユーザアカウントの作成",
  [EMAIL_TEMPLATES.INSTITUTIONAL_ADMIN_INVITE]: "Cycling '74 Admin Portal account creation",
  [EMAIL_TEMPLATES.ADMIN_ACCOUNT_ARCHIVED]: "Admin Info - Archived User Account"
};

exports.AC_SOURCES = sourcesMap(R.range(7, 9))
exports.KEY_SOURCES = sourcesMap(R.range(7, 9))

exports.CURRENT_MAX_VERSION = 'max9';

exports.SYSTEM_ROLES = {
  AUTH_ADMIN: 'auth_admin',
  ACCOUNTING_FINANCE: 'accounting_finance',
  C74_INTERNAL: 'c74-internal',
  CC_ADMIN: 'cc-admin',
  DOCS_ADMIN: 'docs-admin',
  LICENSE_VIEWER: 'license-viewer',
  LICENSE_ADMIN: 'license-admin',
  ROLE_MODERATOR: 'role-moderator',
  NPM_ADMIN: `npm-admin`,
  PM_ADMIN: 'pm-admin',
  WEB_ADMIN: 'web-admin'
};

exports.EXTERNAL_ROLES = {
  C74_CONSULTANT: 'c74-consultant',
  BETA_MODERATOR: 'beta-moderator'
};

exports.ABLETON_ROLES = {
  ABLETON_INTERNAL: 'ableton-internal'
};

exports.BETA_ROLES = {
  MAX_BETA: 'max-beta',
  RNBO_BETA: 'rnbo-beta'
};

const MAX_VERSIONS = {
  MAX7: 'max7',
  MAX8: 'max8',
  MAX9: 'max9'
}

exports.MAX_VERSIONS = MAX_VERSIONS;

const MAX_VERSIONS_DISPLAYNAME = {
  [MAX_VERSIONS.MAX7]: "Max 7",
  [MAX_VERSIONS.MAX8]: "Max 8",
  [MAX_VERSIONS.MAX9]: "Max 9"
};

exports.MAX_VERSIONS_DISPLAYNAME = MAX_VERSIONS_DISPLAYNAME;

const UPGRADE_MECHANISMS = {
  USER: "user",
  RESELLER: "reseller",
  FASTSPRING: "fastspring",
};

exports.UPGRADE_TYPES = UPGRADE_MECHANISMS;

const SUBLICENSE_IDS = {
  RNBO: "rnbo"
};

exports.SUBLICENSE_IDS = SUBLICENSE_IDS;

exports.SUBLICENSE_DISPLAY_NAMES = {
  [SUBLICENSE_IDS.RNBO]: "RNBO",
};

exports.SUBLICENSE_OPTIONS_BY_MAX_VERSION = {
  [MAX_VERSIONS.MAX7]: [],
  [MAX_VERSIONS.MAX8]: [SUBLICENSE_IDS.RNBO],
  [MAX_VERSIONS.MAX9]: [SUBLICENSE_IDS.RNBO]
};

const LICENSE_POOL_PRODUCTS = {
  MAX7: MAX_VERSIONS.MAX7,
  MAX8: MAX_VERSIONS.MAX8,
  MAX9: MAX_VERSIONS.MAX9,
};

exports.LICENSE_POOL_PRODUCTS = LICENSE_POOL_PRODUCTS;

exports.LICENSE_POOL_PRODUCT_DISPLAY_NAME = {
  [LICENSE_POOL_PRODUCTS.MAX7]: MAX_VERSIONS_DISPLAYNAME[MAX_VERSIONS.MAX7],
  [LICENSE_POOL_PRODUCTS.MAX8]: MAX_VERSIONS_DISPLAYNAME[MAX_VERSIONS.MAX8],
  [LICENSE_POOL_PRODUCTS.MAX9]: MAX_VERSIONS_DISPLAYNAME[MAX_VERSIONS.MAX9],
};

exports.LICENSE_POOL_TYPES = {
  FULL: TYPES.FULL,
  SUBSCRIPTION: TYPES.SUBSCRIPTION
};

exports.STATUS = {
  ACTIVE: 'active',
  NOT_ACTIVE: 'not_active',
  PENDING: 'pending'
};

exports.FS_PRODUCT_DISPLAY_NAMES = {
  // Test Products
  "fastspring-test-subscription": "FS Test Subscription",
  "max-test-subscription": "Max Monthly Subscription",

  // Max 7
  "Max 7": "Max 7",
  "Max 7 Academic": "Max 7 Academic",
  "Max 7 Academic Upgrade": "Max 7 Academic Upgrade",
  "Max 7 Crossgrade": "Max 7 Crossgrade",
  "Max 7 Upgrade": "Max 7 Upgrade",

  // Max 8
  "max-8": "Max 8",
  "max-8-academic": "Max 8 Academic",
  "max-8-academic-upgrade": "Max 8 Academic Upgrade",
  "max-8-crossgrade": "Max 8 Crossgrade",
  "max-8-rnbo": "Max 8",
  "max-8-rnbo-academic": "Max 8 Academic",
  "max-8-rnbo-academic-upgrade": "Max 8 Academic Upgrade",
  "max-8-rnbo-crossgrade": "Max 8 Crossgrade",
  "max-8-rnbo-upgrade": "Max 8 Upgrade",
  "max-8-upgrade": "Max 8 Upgrade",

  // Max 9
  "max-9": "Max 9",
  "max-9-academic": "Max 9 for Students",
  "max-9-crossgrade": "Max 9",
  "max-9-upgrade": "Max 9 Upgrade",
  "max-9-rnbo": "Max 9",
  "max-9-rnbo-academic": "Max 9 for Students",
  "max-9-rnbo-crossgrade": "Max 9",
  "max-9-rnbo-upgrade": "Max 9 Upgrade",
  "max-9-rnbo-academic-upgrade": "Max 9 Upgrade",

  // Annual Subs
  "Max 7 Annual Subscription": "Max Annual Subscription",
  "Max Annual Subscription": "Max Annual Subscription",
  "max-annual-subscription": "Max Annual Subscription",

  // Annual Academic Sub
  "Max 7 Annual Subscription Academic": "Max Annual Academic Subscription",
  "Max Annual Subscription Academic": "Max Annual Academic Subscription",
  "max-annual-subscription-academic": "Max Annual Subscription for Students",

  // Monthly Sub
  "Max 7 Monthly Subscription": "Max Monthly Subscription",
  "Max Monthly Subscription": "Max Monthly Subscription",
  "max-monthly-subscription": "Max Monthly Subscription",

  // Staging Subs
  "max-rnbo-annual-subscription": "Max Annual Subscription",
  "max-rnbo-annual-subscription-academic": "Max Annual Academic Subscription",
  "max-rnbo-monthly-subscription": "Max Monthly Subscription"
}

exports.SESSION_LENGTH_VALUES = [
  {text: '15 min', value: 15},
  {text: '30 min', value: 30},
  {text: '1 hour', value: 60},
  {text: '2 hours', value: 120},
  {text: '3 hours', value: 180},
  {text: '1 day', value: 60 * 24},
  {text: '3 days', value: 60 * 24 * 3},
  {text: '1 week', value: 60 * 24 * 7},
  {text: '2 weeks', value: 60 * 24 * 14},
  {text: '1 month', value: 60 * 24 * 30},
  {text: '2 months', value: 60 * 24 * 60},
  {text: '3 months', value: 60 * 24 * 90},
  {text: '6 months', value: 60 * 24 * 180}
];

exports.TOKEN_AUDIENCE = {
  API: 'api',
  MAX: 'max',
  WEB: 'web',
  INST_INVITE: 'inst_invite'
};

exports.ERRORS = {
  connectionRefused: 'Error: API Unreachable',
  databaseUnseeded: 'Error: DB Unreachable',
};



// WEBPACK FOOTER //
// ./server/constants.js